<template lang="pug">
    section.abonement
        el-row
            el-collapse(accordion v-if="blocks && blocks.length")
                transition-group(name="slide-decent-vertical")
                    el-collapse-item(
                        v-for="block in blocks" :key="block.key"
                        v-if="checkConditions(block)"
                        :name="block.key"
                    )
                        template(slot="title")
                            FontAwesomeIcon.icon(v-if="block.icon" :icon="block.icon")
                            FontAwesomeIcon.icon(v-else icon="block")
                            span {{ block.name }}
                        transition-group(name="slide-decent-vertical")
                            .row(
                                v-for="(group, i) in block.groups" :key="i"
                                v-if="checkConditions(group)"
                            )
                                transition-group.flex(name="slide-decent-vertical")
                                    SettingField.setting-field(
                                        v-for="field in group.fields"
                                        v-if="checkConditions(field)"
                                        :key="field.key"
                                        :field="field"
                                        :setting-values="settingValues"
                                    )

</template>

<script>

import _ from 'lodash'
import { mapGetters } from 'vuex'
import SettingField from './Partials/SettingField'
import store from '@/store'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    name: 'AbonementSections',
    components: {
        SettingField,
        FontAwesomeIcon
    },
    computed: {
        settings() {
            const settings = _.get(this.form, 'config.template.settings') || []
            return settings.find(el => el.key === 'sections')
        },
        blocks() {
            return _.get(this.settings, 'blocks') || []
        },
        ...mapGetters({
            form: 'settings/form',
            settingValues: 'settings/values',
            activeCms: 'activeCms'
        })
    },
    methods: {
        checkConditions(setting) {
            let valid = true

            // eslint-disable-next-line no-unused-vars
            const settings = this.settingValues;
            try {
                const conditions = setting.conditions
                if (conditions && conditions.length) {
                    conditions.forEach(o => {
                        if (valid === false) return

                        const { type, condition } = o
                        switch (type) {
                            case 'eval':
                                valid = eval(condition)
                                break;

                            default:
                                valid = false
                        }
                    })
                }
            } catch (error) {
                // eslint-disable-next-line
                console.error(error);
                valid = false
            }

            return valid
        }
    },
    beforeRouteEnter(to, from, next) {
        let cms = _.get(store, 'state.setup.activeCms');

        next(vm => {
            const settings = _.get(vm.form, 'config.template.settings')
                || _.get(vm.activeCms, 'config.template.settings')
                || []

            if (!settings.find(el => el.key === 'sections')) {
                next({ name: 'settings-form' });
            } else {
                next();
            }
        })
    }
}
</script>

<style lang="sass" scoped>
.row
    display: flex
    margin-bottom: 12px
    & > span.flex
        width: 100%
        display: flex
        flex-wrap: wrap
        row-gap: 20px

.setting-field
    margin-right: 20px

.col-right
    img
        width: 90%

.el-main.main-slot .el-form .el-card .el-card__body section > .el-row > .el-col-lg-12:first-child:before
    display: none

.icon
    margin-right: 10px
    height: 18px
    width: 18px
    padding: 7px
    // color: #fff
    // background: #474747
    // border: 1px solid #575757
    // border-radius: 2px
</style>
